import React from 'react';

// Chips dos doutores do Diário e da Semana: Todos e um por doutor do mês, com a contagem do dia ou da semana. Tocar no
// doutor escolhido volta para Todos. counts: 'all' e o id de cada doutor -> número de agendamentos
const DoctorChips = ({ doctors, names, active, counts, onChange }) => (
  <div className='agenda-day-chips' role='group' aria-label='Doutores'>
    <button type='button' className='agenda-day-chip' aria-pressed={active === 'all'} onClick={() => onChange('all')}>
      Todos {counts.get('all') ?? 0}
    </button>
    {doctors.map((doctor) => (
      <button
        key={doctor.id}
        type='button'
        className='agenda-day-chip'
        aria-pressed={active === doctor.id}
        onClick={() => onChange(active === doctor.id ? 'all' : doctor.id)}
      >
        {names.get(doctor.id)} {counts.get(doctor.id) ?? 0}
      </button>
    ))}
  </div>
);

export default DoctorChips;
